import React from 'react';
import '../../styles/eneos.css';

const PrivacyPolicy = () => {
  return (
    <div className="eneos-theme">
      <div className="eneos-container">
        <h1>Privacy Policy</h1>
        <p className="page-info">Last updated: {new Date().toLocaleDateString()}</p>

        <div className="info-box">
          <strong>Your Privacy Matters:</strong> SoftLaabs is committed to protecting your personal information and your right to privacy.
        </div>

        <h2>1. Information We Collect</h2>
        <p>
          We collect information that you provide directly to us when you use our services, including:
        </p>
        <ul>
          <li><strong>Contact Information:</strong> Name, email address, phone number, and company details</li>
          <li><strong>Project Information:</strong> Details about your project requirements and specifications</li>
          <li><strong>Communication Data:</strong> Records of your communications with us</li>
          <li><strong>Technical Data:</strong> IP address, browser type, device information, and usage data</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>We use the information we collect to:</p>
        <ul>
          <li>Provide, maintain, and improve our services</li>
          <li>Respond to your inquiries and provide customer support</li>
          <li>Send you technical notices, updates, and administrative messages</li>
          <li>Communicate with you about products, services, and events</li>
          <li>Monitor and analyze trends, usage, and activities</li>
          <li>Detect, prevent, and address technical issues and security threats</li>
        </ul>

        <h2>3. Information Sharing and Disclosure</h2>
        <p>
          We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:
        </p>
        <ul>
          <li><strong>With Your Consent:</strong> When you explicitly authorize us to share information</li>
          <li><strong>Service Providers:</strong> With trusted third-party service providers who assist in our operations</li>
          <li><strong>Legal Requirements:</strong> When required by law or to protect our rights and safety</li>
          <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets</li>
        </ul>

        <h2>4. Data Security</h2>
        <p>
          We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. These measures include:
        </p>
        <ul>
          <li>Encryption of data in transit and at rest</li>
          <li>Regular security assessments and audits</li>
          <li>Access controls and authentication mechanisms</li>
          <li>Employee training on data protection practices</li>
        </ul>

        <div className="info-box warning">
          <strong>Important:</strong> No method of transmission over the Internet is 100% secure. While we strive to protect your information, we cannot guarantee absolute security.
        </div>

        <h2>5. Data Retention</h2>
        <p>
          We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law. When we no longer need your information, we will securely delete or anonymize it.
        </p>

        <h2>6. Your Rights and Choices</h2>
        <p>You have the following rights regarding your personal information:</p>
        <ul>
          <li><strong>Access:</strong> Request access to your personal information</li>
          <li><strong>Correction:</strong> Request correction of inaccurate or incomplete information</li>
          <li><strong>Deletion:</strong> Request deletion of your personal information</li>
          <li><strong>Objection:</strong> Object to processing of your personal information</li>
          <li><strong>Portability:</strong> Request transfer of your information to another service</li>
          <li><strong>Withdraw Consent:</strong> Withdraw consent for processing at any time</li>
        </ul>

        <h2>7. Cookies and Tracking Technologies</h2>
        <p>
          We use cookies and similar tracking technologies to collect and track information about your use of our services. For more information, please see our <a href="/cookies">Cookie Policy</a>.
        </p>

        <h2>8. Third-Party Links</h2>
        <p>
          Our website may contain links to third-party websites. We are not responsible for the privacy practices of these external sites. We encourage you to read their privacy policies.
        </p>

        <h2>9. Children's Privacy</h2>
        <p>
          Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children. If you become aware that a child has provided us with personal information, please contact us.
        </p>

        <h2>10. International Data Transfers</h2>
        <p>
          Your information may be transferred to and processed in countries other than your country of residence. We ensure appropriate safeguards are in place to protect your information in accordance with this Privacy Policy.
        </p>

        <h2>11. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date. We encourage you to review this Privacy Policy periodically.
        </p>

        <h2>12. Contact Us</h2>
        <p>
          If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us:
        </p>
        <div className="info-box">
          <strong>Email:</strong> <a href="mailto:softlaabs@softlaabs.org">softlaabs@softlaabs.org</a><br />
          <strong>Phone:</strong> +254 792560128<br />
          <strong>Address:</strong> Remote Services Worldwide
        </div>

        <hr />

        <h2>GDPR Compliance (For EU Residents)</h2>
        <p>
          If you are a resident of the European Economic Area (EEA), you have additional rights under the General Data Protection Regulation (GDPR):
        </p>
        <ul>
          <li>Right to be informed about data collection and use</li>
          <li>Right to access your personal data</li>
          <li>Right to rectification of inaccurate data</li>
          <li>Right to erasure ("right to be forgotten")</li>
          <li>Right to restrict processing</li>
          <li>Right to data portability</li>
          <li>Right to object to processing</li>
          <li>Rights related to automated decision-making and profiling</li>
        </ul>

        <h2>CCPA Compliance (For California Residents)</h2>
        <p>
          If you are a California resident, you have rights under the California Consumer Privacy Act (CCPA):
        </p>
        <ul>
          <li>Right to know what personal information is collected</li>
          <li>Right to know if personal information is sold or disclosed</li>
          <li>Right to say no to the sale of personal information</li>
          <li>Right to access your personal information</li>
          <li>Right to equal service and price</li>
        </ul>

        <div style={{ marginTop: '2em' }}>
          <button className="eneos-btn">Download PDF</button>
          {' '}
          <button className="eneos-btn secondary">Print Policy</button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
